import { render } from "./Application.vue?vue&type=template&id=1815e3df&ts=true"
import script from "./Application.vue?vue&type=script&lang=ts"
export * from "./Application.vue?vue&type=script&lang=ts"

import "./Application.vue?vue&type=style&index=0&id=1815e3df&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__